export const StepperRightSvg: string =
`<svg xmlns="http://www.w3.org/2000/svg" class="$state$" width="18" height="22">
  <style>
    path{fill:#666}
    .active path,.hover path{fill:#333}
    .disabled{opacity:0.35!important}
  </style>
  <path d="M7,13.9V7.2C7,7,7.2,7,7.3,7l4.4,3.4c0.1,0.1,0.1,0.2,0,0.3L7.3,14C7.2,14,7,14,7,13.9z" />
</svg>`;
